import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hamiltonLRSFileNameFormat'
})
export class HamiltonLRSFileNameFormatPipe implements PipeTransform {
  static readonly nameFormatPattern = 'LRS_([A-Za-z0-9-]+)\.[A-Za-z0-9-\.]+_([0-9]{6})_([0-9]{2})([0-9]{2})\.txt';

  transform(value: any, args?: any): any {
    if (!value) {
      return value;
    }
    let regex: RegExp = new RegExp(HamiltonLRSFileNameFormatPipe.nameFormatPattern);
    let match: RegExpExecArray = regex.exec(String(value));

    if (match !== null && match.length > 0) {
      return match[1] + ' ' + match[2] + ' ' + match[3] + ':' + match[4];
    }
    return value;
  }
}
